@if(showAsInnerHtml) {
    <div [innerHTML]="getLabel()"></div>
}@else{
    {{getLabel()}}
}

